<div class="text-center px-3 pt-3" data-testid="import-free-first">
  <h2 id="import-free-first-title" class="text-1 fs-4 fw-bold mb-3">{{ 'ITEMS.ImportFreeFirstTitle' | translate }}</h2>
  <p id="import-free-first-message" class="mb-4" data-testid="import-free-first-message">{{ 'ITEMS.ImportFreeFirstMessage' | translate }}</p>
  <div class="d-flex flex-wrap justify-content-center gap-3 pb-2">
    <button type="button" class="btn btn-skyblue-s-1 standard-btn" data-testid="import-free-first-cancel" (click)="answer(false)">{{ 'COMMON.Cancel' | translate }}</button>
    <button type="button" class="btn btn-p-2 standard-btn" data-testid="import-free-first-yes" (click)="answer(true)">{{ 'ITEMS.ImportFreeFirstYes' | translate }}</button>
  </div>
</div>
